module.exports = __webpack_public_path__ + "img/plug_pairing_mode.65d44f70.png";